import { Col, Icon, Row, Spin, Tooltip } from 'antd';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import * as React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { editShipment } from 'src/api/shipmentTracking';
import { commonStyles } from 'src/Library/CommonStyles';
import { OrgTypes } from 'src/Library/Constants';
import { isValidBoolean } from 'src/Library/Helper';
import { RouterProps, StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { containerTrackingPermissions } from 'src/selectors/importsFilter';
import { nl2Br } from 'src/utils/DOMUtils';
import ProductSideDrawer from '../masters/Product/ProductSideDrawer';
import { getFormattedAddress } from '../Triangulation/ContainerTriangulation.utils';
import { COLOR_MAPPING_MOVEMENT_TYPE, MOVEMENT_TYPES, TEAMS_TYPE, TEAM_ICONS } from './ContainerUtils';
import { CardData } from './Interfaces/Shipment.interface';
import { CTPermissions } from './Interfaces/TypesInShipmentTracking';
import { tokens } from 'src/design-system';
import { getShipmentNumber } from './ShipmentTrackingHelper';
const styles = theme => ({
  ...commonStyles(theme),
  modal: {
    minWidth: '90%',
  },
  ['@media (max-width: 1200px)']: {
    modal: {
      minWidth: '1200px',
    },
  },
  titleCol : {
      fontSize: tokens.fontSize.h3,
      lineHeight: '22px',
      fontWeight: tokens.fontWeight.semibold,
  },
  labelStyle: {
      fontSize: tokens.fontSize.small,
      lineHeight: '14px',
  },
  valStyle: {
      fontSize: tokens.fontSize.body,
      lineHeight: '14px',
      fontWeight: tokens.fontWeight.semibold,
  },
  alignStyle: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  mainRowBorder : {
      borderTop: `1px solid ${tokens.colors.border}`,
  },
  imgDiv : {
    borderRight: `1px solid ${tokens.colors.border}`,
    margin: '3% 0 10% 0',
    display: 'flex',
    alignItems: 'center',
  },
  img : {
    width: '80%',
    maxWidth: '80%',
  },
  rowStyle: {
      marginTop: '2%',
      marginBottom: '2%',
      height: '22px',
  },
  dot: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    marginRight: 5,
    display: 'inline-block',
  },
  transparentButton: {
    background: 'transparent',
    border: 'none',
    color: tokens.colors.primary,
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
      background: 'transparent',
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  addressHeading: {
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
  },
  addressOtherDetails: {
    color: tokens.colors.text,
    fontSize: tokens.fontSize.small,
    marginTop: '6px',
  },
  teamStyle: {
    marginLeft: '5px',
    '&.link': {
      color: tokens.colors.primary,
      marginLeft: '8px,'
    },
  }
});
const { useEffect } = React;
interface IProps extends
  ReduxProps,
  RouterProps,
  StylesProps<ReturnType<typeof styles>>{
    match;
    newShipmentView: boolean;
    shipmentDetails: CardData;
    handleReloadClick: () => any;
    isHBL: () => boolean;
    hblNumber?: string;
    trackingType: string;
  }
interface FetchShipmentDetailsProps {
  id: string;
  shipmentType: string;
}
interface ReduxProps {
  permissions: CTPermissions;
  orgType: string;
}
interface StateProps {
  editing?: boolean;
  reload?: boolean;
  selectedSubContainer?: CardData;
  productVisible?: boolean;
}
const ContainerDetails = (props: IProps) => {
  const {
    classes,
    shipmentDetails,
    permissions,
    orgType,
    match,
    newShipmentView,
    isHBL,
    hblNumber,
    trackingType,
  } = props;

  const [state, setState] = useGenericState<StateProps>({});

  const {
    editing,
    reload,
    productVisible,
  } = state;

  useEffect(() => {

  }, [reload]);

  const { blReceived } = props.shipmentDetails;

  function handleProduct(productVisible: boolean) {
    setState({ productVisible });
    //handleCloseProduct();
  }

  const renderProductDrawer = () => {
    if (!productVisible
      //&& productId !== shipmentDetails?.id
      ) return null;  
    return <ProductSideDrawer
      showTracking={false}
      shipmentNumber={getShipmentNumber(props.shipmentDetails)}
      products={shipmentDetails.products || []}
      handleClose={() => handleProduct(false)}
    />;
  };
  async function handleMarkReceived() {
    const { id } = props.match.params;
    const body = isHBL() ? {
      id,
      trackingType,
      hblNumber,
      hblVendor: props.shipmentDetails?.shippingLineId,
      blReceived: !Boolean(blReceived),
      movementType: props.shipmentDetails?.movementType,
    } : {
      ...props.shipmentDetails,
      id,
      trackingType,
      blReceived: !Boolean(blReceived),
    }
    Object.keys(body).forEach(key => {
      if (!body[key]) {
        body[key] = undefined;
      }
    });
    setState({ editing: true });
    const response = await editShipment(body);
    setState({
      editing: false,
      reload: response.isSuccess ? !Boolean(reload) : reload,
    });
    setState({ editing: false});
    props.handleReloadClick();
  }

  const renderMarkContent = () => {
    if (match?.params?.unique_id) return null;
    if (editing) return <Spin size="small"/>;
    return <React.Fragment>
      {renderTooltip()}
      {permissions.write && shipmentDetails.selfShipment && <a
        onClick={handleMarkReceived}
        className={classes.transparentButton}>
        {blReceived ? 'Mark Not Received' : 'Mark Received'}
      </a>}
    </React.Fragment>;
  };
  const renderTooltip = () => {
    const {
      lastBlReceivedAction,
    } = shipmentDetails;
    if (!lastBlReceivedAction) return null;
    return <React.Fragment>
        {isValidBoolean(blReceived) && <span
          style={{
            marginRight: 8,
          }}>
          {blReceived ? 'Yes' : 'No'}
        </span>}
      <Tooltip
        title={lastBlReceivedAction}>
        <Icon
          type="info-circle"
          theme="filled"
        />
        {shipmentDetails.selfShipment && permissions.write && <span style={{
          margin: '0px 5px',
          border: `1px solid ${tokens.colors.textTertiary}`,
        }}/>}
      </Tooltip>
    </React.Fragment>;
  };
  const renderCol = (span, data) => {
    return <Col span={span}>{data}</Col>;
  };
  const renderTitleCol = (text) => {
  return <div className={classes.titleCol}>{text}</div>;
  }
  const renderLabel = (text) => {
  return <div className={classes.labelStyle}>{text}</div>;
  }
  const renderVal = (text) => {
  return <div className={classes.valStyle}>{text}</div>;
  }
  const renderTeamType = () => {
    const { accessorType } = shipmentDetails;
    const teamDetails = shipmentDetails.teamDetails ? shipmentDetails.teamDetails.map(obj => obj.teamName) : undefined;
    if (!accessorType) return null;
    return <div>
      <Icon
        type = {TEAM_ICONS[accessorType]}
      /> 
      {/* {accessorType === 'TEAM' ? shipmentDetails.teamName : TEAMS_TYPE[accessorType]} */}
      <Tooltip
        placement="topLeft"
        title={teamDetails ? teamDetails[0] : ''}
        className={classes.teamStyle}
      >
        {accessorType === 'TEAM' && teamDetails ? teamDetails[0] : accessorType && TEAMS_TYPE[accessorType] || ''}
      </Tooltip>
      {teamDetails && teamDetails.length > 1 && 
        <Tooltip
          placement="topLeft"
          title={teamDetails.slice(1).join("\n")}
          className={`${classes.teamStyle} link`}
          overlayStyle={{ whiteSpace: 'pre-line' }}
        >
          {`+${teamDetails.length - 1} more`}
        </Tooltip>
      }
    </div>;
  };
  const renderLabelVal = (label, val) => {
    return <Row>
      <Col className={classes.alignStyle} span={8}>{renderLabel(label)}</Col>
      <Col className={classes.alignStyle} span={14}>{val ? renderVal(val) : renderVal('-')}</Col>
    </Row>;
  };

  function getMovementType() {
    switch (shipmentDetails.movementType) {
      case MOVEMENT_TYPES.EXPORT: return 'Export';
      case MOVEMENT_TYPES.IMPORT: return 'Import';
      default: return 'Trade';
    }
  }

  const renderBasicDetailsRow1 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Basic Details'))}
      {renderCol(10, renderLabelVal('Movement Type',
        <div>
          <span className={classes.dot}
            style={{
              backgroundColor: COLOR_MAPPING_MOVEMENT_TYPE[shipmentDetails?.movementType || 'EXPORT'],
            }}
          />
          {getMovementType()}
        </div>))}
      {renderCol(10, renderLabelVal('Internal #', shipmentDetails.internalReferenceNumber))}
    </Row>;
  };

  const renderBasicDetailsRow2 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Access', renderTeamType()))}
      {!match?.params?.unique_id &&
        !shipmentDetails?.isArchived &&
        renderCol(10, renderLabelVal('BL Received', renderMarkContent()))}
    </Row>;
  };

  const renderBasicDetailsRow3 = () => {
    const { pgiDate, linkedBlNumber, channel } = shipmentDetails;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('PGI Date', pgiDate ? moment(pgiDate).format('DD MMM YYYY') : '-'))}
      {renderCol(10, !shipmentDetails.bookingNumber && !shipmentDetails.blNumber && renderLabelVal('Channel', channel ? shipmentDetails.channel : '-'))}
    </Row>;
  };

  const renderBasicDetailsRow4 = () => {
    const {soNumber, stuffingId } = shipmentDetails;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('SO Number', soNumber ? shipmentDetails.soNumber : '-'))}
      {renderCol(10, renderLabelVal('Stuffing ID', stuffingId ? shipmentDetails.stuffingId : '-'))}
    </Row>;
  };

  const renderBasicDetailsRow5 = () => {
    const {company, businessLocation } = shipmentDetails;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Company', company ? shipmentDetails.company : '-'))}
      {renderCol(10, renderLabelVal('Business Location', businessLocation ? shipmentDetails.businessLocation : '-'))}
    </Row>;
  };

  const renderBasicDetailsRow6 = () => {
    const {linkedBlNumber} = shipmentDetails;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {linkedBlNumber && renderCol(10, renderLabelVal('Linked BL Number', shipmentDetails.linkedBlNumber))}
    </Row>;
  };

  const renderBasicDetailRow7 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
    {renderCol(4, null)}
    {renderCol(10, renderLabelVal('Shipment Owner', shipmentDetails.shipmentOwner))}
  </Row>;
  };

  const renderRemarks = () => {
    return (
      <Row className={classes.rowStyle} style={{ height: 'unset' }} gutter={30}>
        {renderCol(4, null)}
        <Col className={classes.alignStyle} span={3}>{renderLabel('Remarks')}</Col>
        <Col className={classes.alignStyle} span={16}>
          <span style={{ paddingLeft: '8px' }}>
            {shipmentDetails.remarks ? renderVal(nl2Br(shipmentDetails.remarks, '\n')) : renderVal('-')}
          </span>
        </Col>
      </Row>
    );
  };

  const renderBasicDetails = () => {
    return <div className={classes.mainRowBorder}>
      {renderBasicDetailsRow1()}
      {renderBasicDetailsRow2()}
      {renderBasicDetailsRow3()}
      {!shipmentDetails.bookingNumber && !shipmentDetails.blNumber && renderBasicDetailsRow4()}
      {!shipmentDetails.bookingNumber && !shipmentDetails.blNumber  &&  renderBasicDetailsRow5()}
      {shipmentDetails.linkedBlNumber && renderBasicDetailsRow6()}
      {renderBasicDetailRow7()}
      {renderRemarks()}
    </div>;
  };

  const renderHBLBasicDetailsRow1 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Basic Details'))}
      {renderCol(10, renderLabelVal('NVOCC/FF', shipmentDetails.shippingLineName))}
      {renderCol(10, renderLabelVal('Movement Type', getMovementType()))}
    </Row>;
  };

  const renderHBLBasicDetailsRow2 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Internal Number', shipmentDetails.internalReferenceNumber))}
      {renderCol(10, renderLabelVal('Product(s)', renderProducts()))}
    </Row>;
  };


  const renderHBLBasicDetailsRow3 = () => {
    const { finalEta } = shipmentDetails;
    const finalEtaMoment = moment(finalEta);
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Access', renderTeamType()))}
      {renderCol(10, renderLabelVal('HBL Received', renderMarkContent()))}
    </Row>;
  };
  const renderHBLBasicDetailsRow4 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol(null))}
      {renderCol(10, renderLabelVal('Purchase Order #', shipmentDetails.purchaseOrderNumberList?.join(', ')))}
      {renderCol(10, renderLabelVal('Shipment Owner', shipmentDetails.shipmentOwner))}
    </Row>;
  }

  const renderHBLBasicDetailsRow5 = () => {
    return (
      <Row className={classes.rowStyle} gutter={30}>
        {renderCol(4, renderTitleCol(null))}
        {renderCol(10, renderLabelVal('Incoterm', shipmentDetails.incoterm))}
      </Row>
    );
  }

  const renderHBLBasicDetails = () => {
    return (
      <div className={classes.mainRowBorder}>
        {renderHBLBasicDetailsRow1()}
        {renderHBLCustomer()}
        {renderSupplier()}
        {renderHBLBasicDetailsRow2()}
        {renderHBLBasicDetailsRow3()}
        {renderHBLBasicDetailsRow4()}
        {renderHBLBasicDetailsRow5()}
        {renderRemarks()}
      </div>
    );
  };
  
  const renderHBLAdditionalDetailsRow1 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Additional Details'))}
      {renderCol(10, renderLabelVal('Invoice Number', shipmentDetails.invoiceNumberList?.join(', ')))}
      {renderCol(10, renderLabelVal('Contract Number', shipmentDetails.contractNumber))}
    </Row>;
  };

  const renderHBLAdditionalDetailsRow2 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('HBL Issue Date', shipmentDetails?.blIssueDate ? moment(shipmentDetails.blIssueDate).format('DD MMM YY') : '-'))}
      {renderCol(10, renderLabelVal('Promised Transit Days', shipmentDetails.promisedTransitDays ? `${shipmentDetails.promisedTransitDays} day(s)` : '-'))}
    </Row>;
  };

  const renderHBLAdditionalDetailsRow3 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('PGI Date', shipmentDetails.pgiDate ? moment(shipmentDetails.pgiDate).format('DD MMM YY') : '-'))}
    </Row>;
  };

  const renderHBLAdditionalDetails = () => {
    return <div className={classes.mainRowBorder}>
      {renderHBLAdditionalDetailsRow1()}
      {renderHBLAdditionalDetailsRow2()}
      {renderHBLAdditionalDetailsRow3()}
    </div>;
  };

  const renderOrderDetailsRow1 = () => {
    if (!newShipmentView) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Order Details'))}
      {renderCol(10, renderLabelVal('Purchase Order #', shipmentDetails.purchaseOrderNumberList?.join(', ')))}
      {renderCol(10, renderLabelVal('Sales Order #', shipmentDetails.salesOrderNumber))}
    </Row>;
  };

  const renderOrderDetailsRow2 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol(newShipmentView ? null : 'Order Details'))}
      {renderCol(10, renderLabelVal('Invoice #', shipmentDetails.invoiceNumberList?.join(', ')))}
      {renderCol(10, renderLabelVal('Contract #', shipmentDetails.contractNumber))}
    </Row>;
  };

  const renderOrderDetailsRow3 = () => {
    if (newShipmentView) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol(null))}
      {renderCol(10, renderLabelVal('Purchase Order #', shipmentDetails.purchaseOrderNumberList?.join(', ')))}
    </Row>;
  };

  const renderOrderDetails = () => {
    return <div className={classes.mainRowBorder}>
      {renderOrderDetailsRow1()}
      {renderOrderDetailsRow2()}
      {renderOrderDetailsRow3()}
    </div>;
  };

  const renderServiceRow1 = () => {
    if (!newShipmentView) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Service'))}
      {renderCol(10, renderLabelVal('Incoterm', shipmentDetails.incoterm))}
      {renderCol(10, renderLabelVal('Pickup and Drop', shipmentDetails.pickupAndDrop))}
    </Row>;
  };  

  const renderServiceRow2 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol(newShipmentView ? null : 'Service'))}
      {renderCol(10, renderLabelVal(
        'BL Issue Date',
        shipmentDetails.blIssueDate && moment(shipmentDetails.blIssueDate).format('DD MMM YYYY')))}
      {renderCol(10, renderLabelVal('Promised Transit Days', shipmentDetails.promisedTransitDays))}
    </Row>;
  };

  const renderServiceRowExtra = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Incoterm', shipmentDetails.incoterm))}
    </Row>;
  };

  const renderService = () => {
    return <div className={classes.mainRowBorder}>
      {renderServiceRow1()}
      {renderServiceRow2()}
      {renderServiceRowExtra()}
    </div>;
  };

  const renderShipper = () => {
    if (orgType !== OrgTypes.FF) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Stakeholders'))}
      {renderCol(10, renderLabelVal('Shipper Name', shipmentDetails.shipperName))}
      {renderCol(10, renderLabelVal('Shipper Reference #', shipmentDetails.customerReferenceNumber))}
    </Row>;
  };

  const renderCustomer = () => {
    if (orgType !== OrgTypes.SHIPPER) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Stakeholders'))}
      {renderCol(10, renderLabelVal('Customer Name', shipmentDetails.customerName))}
      {renderCol(10, renderLabelVal('Customer Reference #', shipmentDetails.customerReferenceNumber))}
    </Row>;
  };

  const renderHBLCustomer = () => {
    if (orgType !== OrgTypes.SHIPPER) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Customer Name', shipmentDetails.customerName))}
      {renderCol(10, renderLabelVal('Customer Reference #', shipmentDetails.customerReferenceNumber))}
    </Row>;
  };

  const renderSupplier = () => {
    if (orgType !== OrgTypes.SHIPPER) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Supplier Name', shipmentDetails.supplierName))}
      {renderCol(10, renderLabelVal('Supplier Reference #', shipmentDetails.supplierReferenceNumber))}
    </Row>;
  };

  const renderVendor = () => {
    if (orgType !== OrgTypes.SHIPPER || isHBL()) return null;
    return (
      <Row className={classes.rowStyle} gutter={30}>
        {renderCol(4, null)}
        {renderCol(10, renderLabelVal('FF Name', shipmentDetails.ffName))}
      </Row>
    );
  };

  const renderStakeholders = () => {
    return <div className={classes.mainRowBorder}>
      {renderCustomer()}
      {renderShipper()}
      {renderSupplier()}
      {renderVendor()}
    </div>;
  }
  const renderProducts = () => {
    const { products } = shipmentDetails;
    const count = (products || [])?.length - 1; 
    const product = products?.length ? products[0] : null;
    const name = product?.internalName || '';

    if (count < 0) return null;
    return <div
      className={classes.valStyle}
      onClick={() => handleProduct(true)}>
      {name} {count > 0 ? <span
        style={{
          color: tokens.colors.primary,
          cursor: 'pointer',
          marginLeft: tokens.spacing.sm,
        }}> <Icon type="plus"/> {count} more</span> : null} </div>
  } 
  const renderContentsRow1 = () => {
    const cargoAndProduct = shipmentDetails.cargo && shipmentDetails.cargoProduct ? 
    `${shipmentDetails.cargo}, ${shipmentDetails.cargoProduct}` : shipmentDetails.cargo ?
    shipmentDetails.cargo : null;
    return <Row className={classes.rowStyle} gutter={30}>
    {renderCol(4, renderTitleCol('Contents'))}
    {renderCol(10, renderLabelVal('Cargo & Product', cargoAndProduct))}
    {renderCol(10, renderLabelVal('Product', renderProducts()))}
    </Row>;
  };

  const renderContents = () => {
    if (!newShipmentView) return null;
    return <div className={classes.mainRowBorder}>
        {renderContentsRow1()}
    </div>;
  };

  const renderAddressRow1 = () => {
    const origin = shipmentDetails.originPort ? `${shipmentDetails.originPort}, ${shipmentDetails.originPortCode}` : null;
    const destination = shipmentDetails.destinationPort ? `${shipmentDetails.destinationPort}, ${shipmentDetails.destinationPortCode}` : null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Address'))}
      {renderCol(10, renderLabelVal('Origin', origin))}
      {renderCol(10, renderLabelVal('Destination', destination))}
    </Row>;
  };

  const renderAddressRow2 = () => {
    if (!newShipmentView) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Origin Country', shipmentDetails.originCountry))}
      {renderCol(10, renderLabelVal('Destination Country', shipmentDetails.destinationCountry))}
    </Row>;
  };
  
  const renderServices = (data) => {
    if (!data) return null;
    return data.map(item => <Row>{item}</Row>);
  }

  const renderAddressRow3 = () => {
    if (!newShipmentView) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Origin Address', shipmentDetails.originAddress))}
      {renderCol(10, renderLabelVal('Destination Address', shipmentDetails.destinationAddress))}
    </Row>;
  };

  const renderAddressRow4 = () => {
    if (!newShipmentView) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Origin Services', renderServices(shipmentDetails.originServices)))}
      {renderCol(10, renderLabelVal('Destination Services', renderServices(shipmentDetails.destinationServices)))}
    </Row>;
  };

  const renderAddressRow5 = () => {
    if (!newShipmentView) return null;
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('Stuffing Location', shipmentDetails.stuffingLocation))}
      {renderCol(10, renderLabelVal('De-Stuffing Location', shipmentDetails.deStuffingLocation))}
    </Row>;
  };

  const renderAddress = () => {
    return <div className={classes.mainRowBorder}>
      {renderAddressRow1()}
      {renderAddressRow2()}
      {renderAddressRow3()}
      {renderAddressRow4()}
      {renderAddressRow5()}
    </div>;
  };

  const renderDemurrageRow1 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, renderTitleCol('Demurrage and Detention'))}
      {renderCol(10, renderLabelVal('Demmurage Free Days', shipmentDetails.demurrageFreeDays))}
      {renderCol(10, renderLabelVal('Detention Free Days', shipmentDetails.detentionFreeDays))}
    </Row>;
  };

  const renderDemurrageRow2 = () => {
    return <Row className={classes.rowStyle} gutter={30}>
      {renderCol(4, null)}
      {renderCol(10, renderLabelVal('CFS Free Days', shipmentDetails.cfsFreeDays))}
      {renderCol(10, null)}
    </Row>;
  };

  const renderDemurrage = () => {
    return <div className={classes.mainRowBorder}>
      {renderDemurrageRow1()}
      {renderDemurrageRow2()}
    </div>;
  };

  const renderOrganisation = () => {
    if (!shipmentDetails?.customFields?.length) return null;
    return <Row
      className={[classes.rowStyle, classes.mainRowBorder].join(' ')}
      gutter={30}
      style={{ paddingTop: 16 }}
    >
      {renderCol(4, renderTitleCol('Organisation Fields'))}
      {renderCol(10, shipmentDetails?.customFields?.map((item, idx) => {
          if (idx %2 === 0) {
            return <div
              style={{ margin: '8px 0px 15px 0px' }}>
              {renderLabelVal(item.description, item.value)}
            </div>;
          } else return null;
        }))}
      {renderCol(10, shipmentDetails?.customFields?.map((item, idx) => {
          if (idx %2) {
            return <div
              style={{ margin: '8px 0px 15px 0px' }}>
              {renderLabelVal(item.description, item.value)}
            </div>;
          } else return null;
        }))}
    </Row>;
  };

  const renderTerms = () => {
    if (!newShipmentView) return null;
    return <Row className={classes.rowStyle}
      gutter={30}>
      {renderCol(4, renderTitleCol('Terms'))}
      {renderCol(10, renderLabelVal('Terms & Condition', shipmentDetails.termsAndConditions))}
      {renderCol(10, null)}
    </Row>;
  };

  const renderTnc = () => {
    return <div className={classes.mainRowBorder}>
        {renderTerms()}
    </div>;
  };

  const renderImportAddress = () => {
    return (
      <div className={classes.mainRowBorder}>
        <Row style={{ margin: '2% 0' }}>
          {renderCol(4, renderTitleCol('Import Address'))}
          <Col span={6}>
            <div className={classes.addressHeading}>{shipmentDetails.addressObject?.name}</div>
            <div className={classes.addressOtherDetails}>{getFormattedAddress(shipmentDetails.addressObject)}</div>
          </Col>
        </Row>
      </div>
    );
  };

  return <div
    style={{
      paddingLeft: 16,
      backgroundColor: 'white',
    }}
  >
    <Row>
      {renderProductDrawer()}
      {!isHBL() ? <div>
      {renderBasicDetails()}
      {renderOrderDetails()}
      {renderService()}
      {renderStakeholders()}
      {renderContents()}
      {!isEmpty(shipmentDetails.addressObject) && renderImportAddress()}
      {renderAddress()}
      {renderDemurrage()}
      {renderOrganisation()}
      {renderTnc()}
      </div> : <div>
        {renderHBLBasicDetails()}
        {renderHBLAdditionalDetails()}
      </div>}
    </Row>
  </div>;
};
const mapStateToProps = ({ masterData }) => ({
  permissions: containerTrackingPermissions(masterData),
  orgType: masterData.userData.type,
});

export default withRouter(React.memo(connect(mapStateToProps)(injectSheet(styles)(ContainerDetails))));
